/* tslint:disable */
/* eslint-disable */
/**
 * Trendtours CMS API
 * ISO API for the IBE. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiFaq
 */
export interface ApiFaq {
    /**
     * 
     * @type {string}
     * @memberof ApiFaq
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ApiFaq
     */
    faqDescription: string;
}

export function ApiFaqFromJSON(json: any): ApiFaq {
    return ApiFaqFromJSONTyped(json, false);
}

export function ApiFaqFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiFaq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'faqDescription': json['faqDescription'],
    };
}

export function ApiFaqToJSON(value?: ApiFaq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'faqDescription': value.faqDescription,
    };
}


// custom code here ##################################################################################################################
function toUTC(date) {
  var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
  return new Date(date_utc);
}
